import type { Point, Viewport } from "../types";

/** Client (screen) coordinates to world coordinates for a given viewport. */
export const clientToWorld = (
  svg: SVGSVGElement,
  viewport: Viewport,
  client: Point
): Point => {
  const rect = svg.getBoundingClientRect();
  return {
    x: (client.x - rect.left - viewport.x) / viewport.scale,
    y: (client.y - rect.top - viewport.y) / viewport.scale
  };
};

export const isPrimaryButton = (event: PointerEvent): boolean =>
  event.button === 0;

export const isMiddleButton = (event: PointerEvent): boolean =>
  event.button === 1;

export const isModifierKey = (event: { metaKey: boolean; ctrlKey: boolean }) =>
  event.metaKey || event.ctrlKey;
